import { SandboxEntityType } from "../types/entities";

const ENTITY_TYPES: SandboxEntityType[] = ["artist", "genre", "venue", "event"];

const ENTITY_ROW_CLASSES: Record<SandboxEntityType, string> = {
  artist: "bg-violet-50 dark:bg-violet-950/30",
  genre: "bg-sky-50 dark:bg-sky-950/30",
  venue: "bg-amber-50 dark:bg-amber-950/30",
  event: "bg-emerald-50 dark:bg-emerald-950/30",
};

const ENTITY_LABEL_CLASSES: Record<SandboxEntityType, string> = {
  artist: "text-violet-700 dark:text-violet-300",
  genre: "text-sky-700 dark:text-sky-300",
  venue: "text-amber-700 dark:text-amber-300",
  event: "text-emerald-700 dark:text-emerald-300",
};

const ENTITY_BADGE_CLASSES: Record<SandboxEntityType, string> = {
  artist: "bg-violet-100 text-violet-800 border-violet-200",
  genre: "bg-sky-100 text-sky-800 border-sky-200",
  venue: "bg-amber-100 text-amber-800 border-amber-200",
  event: "bg-emerald-100 text-emerald-800 border-emerald-200",
};

const ENTITY_TYPE_LABELS: Record<SandboxEntityType, string> = {
  artist: "Artist",
  genre: "Genre",
  venue: "Venue",
  event: "Event",
};

export {
  ENTITY_TYPES,
  ENTITY_ROW_CLASSES,
  ENTITY_LABEL_CLASSES,
  ENTITY_BADGE_CLASSES,
  ENTITY_TYPE_LABELS,
};
